var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'side-opened': _vm.sideOpened, 'pulling': _vm.pulling },style:({ 'left' : _vm.sidePulledLeft }),attrs:{"id":"songs-side"}},[_c('SongsFilter'),_c('Songs'),(_vm.showHelpMoreSongs)?_c('HelpMoreSongs'):_vm._e(),_c('br'),_c('br'),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }